
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 11.085V16.3a3.035 3.035 0 01-3.015 3.024H3.025A3.03 3.03 0 010 16.299V3.024A3.037 3.037 0 013.024 0h6.893c.352 0 .64.288.64.64 0 .353-.288.64-.64.64H3.024c-.955 0-1.744.789-1.744 1.744V16.3c0 .955.789 1.744 1.744 1.744h13.961c.956 0 1.744-.789 1.744-1.744v-5.214c0-.352.288-.64.64-.64.353 0 .631.288.631.64zM5.436 10.78l9.416-9.415a1.631 1.631 0 012.031-.214l.01-.046.26.25 1.39 1.392c.622.63.622 1.66 0 2.3l-9.415 9.425a.66.66 0 01-.325.177l-3.478.695c-.047.01-.084.01-.13.01a.644.644 0 01-.631-.77l.696-3.47a.62.62 0 01.176-.334zm11.698-6.122l.5-.501a.342.342 0 000-.492l-1.391-1.391a.359.359 0 00-.492 0l-.5.5 1.883 1.884zm-7.987 7.977l7.077-7.068-1.883-1.883-7.078 7.078 1.884 1.873zm-.993.826l-1.716-1.725-.427 2.152 2.143-.427z"}})])
          )
        }
      }
    